module.exports = __webpack_public_path__ + "static/media/rrcelogo.be203835.png";